import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import * as styles from '@twistopayments/design-system/styles'

export const container = (theme: Theme) => css`
  display: grid;
  grid-auto-flow: row;
  position: fixed;
  z-index: ${styles.zIndex.toast};
  width: 100%;
  max-width: ${styles.width.container.tiny};
  bottom: ${theme.spacing[8]};
  right: 0;
  pointer-events: none;
  padding-left: ${theme.spacing[8]};

  ${styles.breakpoint.up('sm')} {
    bottom: ${theme.spacing[88]};
    padding-left: 0;
  }
`

export const wrapper = (theme: Theme) => css`
  width: 100%;
  transform-origin: center center;
  transform-style: preserve-3d;
  background: ${theme.palette.background.main};
  border-top-left-radius: ${theme.borderRadius.md};
  border-bottom-left-radius: ${theme.borderRadius.md};
  margin: 0 0 ${theme.spacing[8]} 0;
`
